import { getMostRecentFieldValue } from '@fs/zion-sls'

const commonFactTypes = [
  'BUR_METHOD',
  'CLAN',
  'EDUCATION',
  'ETHNICITY',
  'MARITAL_STATUS',
  'MIL_RANK',
  'NATIONALITY',
  'OCCUPATION',
  'RELIGION',
  'TRIBE_OR_CLAN',
]
export const filterOutTheseFactTypes = [
  'SEX_CODE',
  'RACE_OR_COLOR',
  'AGE',
  'AGE_HOURS',
  'AGE_DAYS',
  'AGE_MINUTES',
  'AGE_MONTHS',
  'AGE_SECONDS',
  'AGE_WEEKS',
  'AGE_YEARS',
]

/**
 * Determines if a fact type is valid for use as an additional fact.
 * A valid additional fact must be editable, displayable, and applicable to a person element.
 *
 * @param {Object} type - The fact type object to validate
 * @param {boolean} type.editable - Whether the fact type can be edited
 * @param {boolean} type.displayable - Whether the fact type should be displayed
 * @param {string[]} type.elementTypes - Array of element types this fact can be associated with
 * @returns {boolean} True if the type meets all criteria for an additional fact
 */
export const isValidAdditionalFactType = (type) => {
  return Boolean(
    type?.editable && // Only include editable facts
    type?.displayable && //  Only include displayable facts
    type?.elementTypes?.includes('PERSON')
  )
}

export const getAdditionalFactOptions = (types) => {
  const commonFacts = []
  const otherFacts = []

  types.fields.forEach((type) => {
    if (
      !filterOutTheseFactTypes.includes(type.fieldType) && // Filter out unwanted fact types
      isValidAdditionalFactType(type) // Ensure the fact type is valid for additional facts
    ) {
      if (commonFactTypes.includes(type.fieldType)) {
        commonFacts.push({
          label: type.displayLabel,
          value: type.fieldType,
        })
      } else {
        otherFacts.push({
          label: type.displayLabel,
          value: type.fieldType,
        })
      }
    }
  })

  return {
    commonFacts,
    otherFacts,
  }
}

export const prepareAdditionalFactDefaultValues = (additionalFacts) => {
  const valueArr = additionalFacts.map((fact) => {
    return {
      label: fact.displayLabel,
      value: getMostRecentFieldValue(fact) || '',
      key: fact.fieldType,
      id: fact.id,
      superElements: fact.superElements,
      editable: fact?.typeData?.editable ?? true,
      dispatches: [],
      locked: fact.superElements?.length > 1,
      added: !fact.id, // If there's no ID, it's a newly added fact
    }
  })

  return { additionalFacts: valueArr }
}
